export default __webpack_public_path__ + "static/instar-homekit-8001-bc72f781894ebc57c482145a9cb0741f.webp";